import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5b8558be&scoped=true&lang=pug&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=5b8558be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8558be",
  null
  
)

export default component.exports